module.exports = __webpack_public_path__ + "img/f1a00d6.svg";